// See https://developers.facebook.com/docs/sharing/reference/share-dialog/

// Defined in views/facebook/_app_id.html.slim
declare global {
  interface Window {
    facebookAppId: string;
  }
}

export const openFacebookShareDialog = (url: string) => {
  const params = new URLSearchParams({
    app_id: window.facebookAppId,
    display: 'popup',
    href: url,
  }).toString();

  const shareDialogUrl = `https://www.facebook.com/dialog/share?${params}`;

  window.open(
    shareDialogUrl,
    'fb-share-dialog',
    'width=800,height=600,toolbar=0,location=0,menubar=0',
  );
};
